import '../../estilo/widgets/_buscador.scss'

export function iniciar() {
  document.querySelector('.grupo.buscador .buscar').onclick = () => {
    redireccionBusqueda()
  }
  document.querySelector('.grupo.buscador .texto').addEventListener('keypress', e => {
    if (e.keyCode === 13) redireccionBusqueda()
  })
  function redireccionBusqueda() {
    const busqueda = document.querySelector('.grupo.buscador .texto').value
    if (busqueda === '') return
    const setIdiomas = ['es', 'en', 'ca', 'fr', 'pt']
    const idiomaBusqueda = {
      es: 'busqueda',
      en: 'search',
      ca: 'recerca',
      fr: 'recherche',
      pt: 'procura'
    }
    const partes = document.location.pathname.split('/')
    const idioma = setIdiomas.includes(partes[1]) ? partes[1] : setIdiomas[0]
    const idiomaUrl = setIdiomas.includes(partes[1]) ? partes[1] : ''
    const rutaIdioma = idiomaUrl === '' ? '' : `/${idiomaUrl}`
    window.location.href = `${rutaIdioma}/blog/${idiomaBusqueda[idioma]}?b=${busqueda}`
  }
}
